import { createStore, compose, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { routerMiddleware } from 'react-router-redux'

import rootReducer from '../reducers'

const initialState = {
}

const enhancers: any = []

export const setupStore = (history: any) => {
    // throw `Implement this func`
    const middleware = [
        thunk,
        routerMiddleware(history)
    ]

    const composedEnhancers = compose(
        applyMiddleware(...middleware),
        ...enhancers
    )


    return createStore(
        rootReducer,
        initialState,
        composedEnhancers
    )
}


// WEBPACK FOOTER //
// ./src/store/setupStore.prod.ts